import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * AI Context: MinimalLayout Component
 *
 * Purpose: Transparent layout wrapper for pages that don't need the full application shell.
 *          Each page controls its own layout, background, and positioning.
 * Location: src/components/layout/MinimalLayout.tsx
 * Usage: Used as a layout route wrapper in Routes.tsx.
 *
 * Design decision: This layout is intentionally transparent (no styling).
 * Pages like login, OAuth callbacks, and access gates have unique layout needs
 * (centered vs. left-aligned, different backgrounds, etc.) so they control their own layout.
 */
const MinimalLayout = ({ children }: { children?: ReactNode }) => {
  return <>{children ?? <Outlet />}</>;
};

export default MinimalLayout;
